module.exports = __webpack_public_path__ + "static/media/Lock.f27a05d3.svg";